import React, {useMemo} from 'react';
import {Image, View} from 'react-native';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import theme from '@/style';
import HomeChat from '../components/home-chat';
import {useLuckySpinModal} from '@/common-pages/luckyspin/luckyspin.hooks';

const turntableImg = require('@/assets/anna/home/turntable.png');
const floatingToolsStyle = {
  right: 12,
  bottom: 48,
  zIndex: 50,
};
const turntableWrapStyle = {marginTop: 8};
const turntableImageStyle = {width: 60, height: 60};

const AnnaFloatingTools = ({visible = true}: {visible?: boolean}) => {
  const {renderModal, show} = useLuckySpinModal({});
  const animatedStyle = useMemo(
    () => ({
      opacity: visible ? 1 : 0,
      transform: [{translateY: visible ? 0 : 16}],
    }),
    [visible],
  );

  return (
    <>
      <View
        pointerEvents={visible ? 'auto' : 'none'}
        style={[
          theme.position.abs,
          theme.flex.col,
          theme.flex.centerByCol,
          floatingToolsStyle,
          animatedStyle,
        ]}>
        <HomeChat />
        <NativeTouchableOpacity onPress={show} style={turntableWrapStyle}>
          <Image source={turntableImg} style={turntableImageStyle} />
        </NativeTouchableOpacity>
      </View>
      {renderModal}
    </>
  );
};

export default AnnaFloatingTools;
